import { render, staticRenderFns } from "./FileFormats.vue?vue&type=template&id=1637cc65&shadow"
import script from "./FileFormats.vue?vue&type=script&lang=js&shadow"
export * from "./FileFormats.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./FileFormats.vue?vue&type=style&index=0&id=1637cc65&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports